module.exports = __webpack_public_path__ + "img/mirta-logo-white.f6d66e5d.png";